import { render, staticRenderFns } from "./DxSelectItemsDriver.vue?vue&type=template&id=8f496ea4&"
import script from "./DxSelectItemsDriver.vue?vue&type=script&lang=js&"
export * from "./DxSelectItemsDriver.vue?vue&type=script&lang=js&"
import style0 from "./DxSelectItemsDriver.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports